module.exports = __webpack_public_path__ + "127a7c05baf7cd13b765588b004376dc.png";